// extracted by mini-css-extract-plugin
export default {"input_container":"styles_input_container__IdU2L","input":"styles_input__SA2lb","label":"styles_label__w9UCd"};